module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.fee66e71.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 972
// module chunks = 7